import { Injectable } from '@angular/core';
import { format, formatDistance, parseISO } from 'date-fns';
import { map } from 'rxjs';
import { BaseService } from 'src/app/helpers/base.service';
import {
  iFeatureResult,
  iFeatureResultDto,
} from 'src/app/helpers/Interfaces/features';
import {
  iPaginationRequest,
  iPaginationResult,
} from 'src/app/helpers/Interfaces/pagination';
import { environment } from 'src/environments/environment.development';
import { CustomerService } from '../../lead-konnekt/customer/customer.service';

@Injectable({
  providedIn: 'root',
})
export class FeaturesService extends BaseService {
  private _getAllFeatures = `${environment.base_url}/api/Feature/GetAllWithRelationship`;
  private _getAllFeatures1 = `${environment.base_url}/api/Feature/GetAllWithRelationshipWithFilteration`;
  private _getFeaturesWithRelation = `${environment.base_url}/api/Feature/GetWithRelationShip`;
  private _getFeatures = `${environment.base_url}/api/Feature/GetAll`;
  private _getFeaturesByModule = `${environment.base_url}/api/Feature/GetByModule`;
  private _getFeaturesBySubmodule = `${environment.base_url}/api/Feature/GetBySubmodule`;
  private _getFeatureCustomers = `${environment.base_url}/api/FeatureCustomers/GetByFeatureId`;
  private _addFeatureCustomer = `${environment.base_url}/api/FeatureCustomers/Add`;
  private _removeFeatureCustomer = `${environment.base_url}/api/FeatureCustomers/RemoveNew`;
  private _addFeature = `${environment.base_url}/api/Feature/Add`;
  private _addFeatureFiles = `${environment.base_url}/api/FeatureFiles/AddRangeFiles`;
  private _updateFeature = `${environment.base_url}/api/Feature/Update`;
  private _removeFeature = `${environment.base_url}/api/Feature/Remove`;
  private _removeFeatureFIle = `${environment.base_url}/api/FeatureFiles/Remove`;
  constructor(private _customerServ: CustomerService) {
    super();
  }

  private processFiles(files: any[]): any[] {
    return files.map((file) => ({
      ...file,
      name: file.fileName ?? file.name,
      size: `(${((file.fileSize ?? file.size) / 1024)
        .toFixed()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} KB)`,
    }));
  }

  private processFeature(res: iFeatureResult): iFeatureResultDto {
    const feature: iFeatureResultDto = { ...res, des: null, createdAt: null };
    feature.des = `${feature.description || ''}${feature.description && feature.body ? ' - ' : ''
      }${feature.body || ''}`;
    feature.createdAt = formatDistance(
      parseISO(feature.createdDate as string),
      new Date(),
      {
        addSuffix: true,
        includeSeconds: true,
      }
    );
    feature.createdDate = format(
      parseISO(feature.createdDate as string),
      'MMM do, yyyy'
    );
    feature.files = this.processFiles(feature.files);
    return feature;
  }

  public GetAllFeatures() {
    return this._http
      .get<any>(this._getAllFeatures, { responseType: 'json' })
      .pipe(
        map((features) =>
          features.map((feature: any) => this.processFeature(feature)).reverse()
        )
      );
  }
  public GetAllFeatures1(payload: iPaginationRequest) {
    return this._http
      .post<iPaginationResult<iFeatureResult>>(this._getAllFeatures1, payload, {
        responseType: 'json',
      })
      .pipe(
        map((res) => ({
          ...res,
          data: res.data.map((feature) => this.processFeature(feature)),
        }))
      );
  }
  public GetFeaturesWithRelation(payload: {
    projectId?: string;
    moduleId?: string;
  }) {
    return this._http
      .post<any>(this._getFeaturesWithRelation, payload, {
        responseType: 'json',
      })
      .pipe(
        map((features) =>
          features.map((feature: any) => this.processFeature(feature))
        )
      );
  }
  public GetFeatures(id?: string) {
    return this._http
      .get<any>(
        id ? `${this._getFeaturesByModule}?Id=${id}` : this._getFeatures,
        { responseType: 'json' }
      )
      .pipe(
        map((features) =>
          features.map((feature: any) => this.processFeature(feature)).reverse()
        )
      );
  }
  public GetFeaturesBySubmodule(id?: string) {
    return this._http
      .get<any>(
        id ? `${this._getFeaturesBySubmodule}?Id=${id}` : this._getFeatures,
        { responseType: 'json' }
      )
      .pipe(
        map((features) =>
          features.map((feature: any) => this.processFeature(feature)).reverse()
        )
      );
  }
  private ShapePayload(data: any) {
    const {
      title,
      description,
      moduleId,
      submoduleId,
      body,
      etr,
      startDate,
      endDate,
    } = data;

    const toIso = (value: any) =>
      value ? (typeof value === 'string' && value.includes('T') ? value : new Date(value).toISOString()) : null;

    return {
      title,
      description,
      moduleId,
      submoduleId,
      body,
      etr: `${etr}`,
      startDate: toIso(startDate),
      endDate: toIso(endDate),
    } as any;
  }
  public AddFeature(data: any) {
    const payload = this.ShapePayload(data);
    return this._http
      .post<any>(this._addFeature, payload, {
        responseType: 'json',
      })
      .pipe(map((feature) => this.processFeature(feature)));
  }

  public UpdateFeature(data: any) {
    const payload = this.ShapePayload(data);
    payload.id = data.id;
    return this._http
      .put<any>(this._updateFeature, payload, {
        responseType: 'json',
      })
      .pipe(map((feature) => this.processFeature(feature)));
  }

  public AddFeatureFiles(Files: FormData) {
    return this._http
      .post<any>(`${this._addFeatureFiles}`, Files, {
        responseType: 'json',
      })
      .pipe(map((files) => this.processFiles(files)));
  }

  public DeleteFeature(id: any) {
    return this._http.delete(`${this._removeFeature}?id=${id}`);
  }
  public DeleteFeatureFile(id: string) {
    return this._http.delete(`${this._removeFeatureFIle}?id=${id}`);
  }
  private customers: any[] = [];
}
